import { Row, Col } from 'react-bootstrap';
import RegistrationForm from '../components/RegistrationForm';
import TitleCard from '../components/TitleCard';
import Logo from '../components/Logo';
const RegisterPage = ({ title = 'Register New User' }) => {
  return (
    <>
      <Logo />
      <Row className="mb-5">
        <Col xs={12} md={10} lg={8} className="mx-auto">
          <TitleCard title={title}>
            <RegistrationForm />
          </TitleCard>
        </Col>
      </Row>
    </>
  );
};

export default RegisterPage;
